import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ProjectAuditoryMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.projectAuditory.projectAuditoryMapperError"));

        Object.setPrototypeOf(this, ProjectAuditoryMapperError.prototype);
    }
}